<template>
  <el-container>
    <!-- 页面头部菜单 -->
    <el-header style="padding: 0; height: 60px">
      <el-row>
        <el-col :xl="8" :lg="6" :md="5" style="background-color: #001529">
          <div v-if="isMobile" class="logo_and_title">
            <img :src="logoDefault" style="height: 43px; width: 200px; margin:7px 0 0 15px" />
            <!-- <span class="system_title">瑞翼教育</span> -->
          </div>
        </el-col>
        <el-col :xl="8" :lg="12" :md="14">
          <el-menu
            :default-active="activeIndex"
            class="page_menu"
            mode="horizontal"
            background-color="#001529"
            text-color="#fcfcfc"
            active-text-color="#449aff"
            @select="handleMenuSelect"
          >
            <el-menu-item index="1"><span style="font-size: 18px">课程体系</span></el-menu-item>
            <el-menu-item index="2"><span style="font-size: 18px">教材专区</span></el-menu-item>
            <el-menu-item v-if="isMobile" index="3"><span style="font-size: 18px">职业路径</span></el-menu-item>
            <el-menu-item v-if="isMobile" index="4"><span style="font-size: 18px">数据集</span></el-menu-item>
          </el-menu>
        </el-col>
        <el-col :xl="8" :lg="6" :md="5" style="background-color: #001529">
          <a href="/login" target="_blank" class="login_button">登录</a>
        </el-col>
      </el-row>
    </el-header>
    <!-- 页面主体 -->
    <el-main v-loading="loading" class="page_main" style="padding: 0">
      <Home v-if="activeIndex === '1'" />
      <Book v-else-if="activeIndex === '2'" />
      <CareerPath v-if="activeIndex === '3'" />
      <Dataset v-else-if="activeIndex === '4'" />
    </el-main>
    <!-- 页面尾部 -->
    <el-footer height="20">
      <div class="bottom_info"><div><span>Copyright</span><span> (C)2022, 瑞翼教育 </span></div></div>
    </el-footer>
  </el-container>
</template>

<script>
import Home from './components/Home.vue'
import Dataset from './components/Dataset.vue'
import Book from './components/Book.vue'
import CareerPath from './components/CareerPath.vue'

import logoSrcPath from '/src/assets/logo.png'

export default {
  name: 'App',
  components: {Home, Book, CareerPath, Dataset},
  data() {
    return {
      logoDefault: logoSrcPath,
      activeIndex: '1',
      loading: false,
      isMobile: true
    }
  },
  created(){
    this.handleResize()
  },
  methods: {
    handleMenuSelect(index) {
      this.activeIndex = index
    },
    handleResize (event) {
      this.fullWidth = document.documentElement.clientWidth;
      // 页面宽度小于1000px时，不显示logo
      if (this.fullWidth < 1000) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
}
</script>

<style>
.logo_and_title {
  display: flex;
}
.system_title {
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
  margin: 13px 0 0 10px;
}
.page_menu {
  justify-content: center;
}
.login_button {
  color: #fff;
  text-decoration: none;
  line-height: 60px;
  width: 60px;
  position: absolute;
  right: 0;
}
.page_main {
  height: calc(100vh - 95px);
}
.bottom_info {
  color: #888;
  height: 20px;
  width: 100%;
  line-height: 12px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>
